// Generated by purs version 0.11.7
"use strict";
var Data_Foreign = require("../Data.Foreign");
var Data_Foreign_Class = require("../Data.Foreign.Class");
var Data_Foreign_Generic = require("../Data.Foreign.Generic");
var Data_Foreign_Generic_Class = require("../Data.Foreign.Generic.Class");
var Data_Generic_Rep = require("../Data.Generic.Rep");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show");
var Data_Show = require("../Data.Show");
var Data_Symbol = require("../Data.Symbol");
var FRP_Event = require("../FRP.Event");
var Halogen_VDom_Types = require("../Halogen.VDom.Types");
var Prelude = require("../Prelude");
var PrestoDOM_Types_DomAttributes = require("../PrestoDOM.Types.DomAttributes");
var FirstScreen = (function () {
    function FirstScreen(value0) {
        this.value0 = value0;
    };
    FirstScreen.create = function (value0) {
        return new FirstScreen(value0);
    };
    return FirstScreen;
})();
var SecondScreen = (function () {
    function SecondScreen(value0) {
        this.value0 = value0;
    };
    SecondScreen.create = function (value0) {
        return new SecondScreen(value0);
    };
    return SecondScreen;
})();
var Props = (function () {
    function Props(value0) {
        this.value0 = value0;
    };
    Props.create = function (value0) {
        return new Props(value0);
    };
    return Props;
})();
var ValueS = (function () {
    function ValueS(value0) {
        this.value0 = value0;
    };
    ValueS.create = function (value0) {
        return new ValueS(value0);
    };
    return ValueS;
})();
var ValueI = (function () {
    function ValueI(value0) {
        this.value0 = value0;
    };
    ValueI.create = function (value0) {
        return new ValueI(value0);
    };
    return ValueI;
})();
var genericFirstScreen = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof FirstScreen) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof SecondScreen) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at PrestoDOM.Types line 32, column 8 - line 32, column 55: " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new FirstScreen(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new SecondScreen(x.value0);
    };
    throw new Error("Failed pattern match at PrestoDOM.Types line 32, column 8 - line 32, column 55: " + [ x.constructor.name ]);
});
var showScreen = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericFirstScreen)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
    return "FirstScreen";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
    return "SecondScreen";
})))));
var encodeFirstScreen = new Data_Foreign_Class.Encode(Data_Foreign_Generic.genericEncode(genericFirstScreen)(Data_Foreign_Generic_Class.genericEncodeSum(Data_Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "FirstScreen";
}))(Data_Foreign_Generic_Class.genericEncodeArgsArgument(Data_Foreign_Class.intEncode)))(Data_Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "SecondScreen";
}))(Data_Foreign_Generic_Class.genericEncodeArgsArgument(Data_Foreign_Class.intEncode))))((function () {
    var $11 = {};
    for (var $12 in Data_Foreign_Generic.defaultOptions) {
        if ({}.hasOwnProperty.call(Data_Foreign_Generic.defaultOptions, $12)) {
            $11[$12] = Data_Foreign_Generic["defaultOptions"][$12];
        };
    };
    $11.unwrapSingleConstructors = false;
    return $11;
})()));
var decodeFirstScreen = new Data_Foreign_Class.Decode(Data_Foreign_Generic.genericDecode(genericFirstScreen)(Data_Foreign_Generic_Class.genericDecodeSum(Data_Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "FirstScreen";
}))(Data_Foreign_Generic_Class.genericDecodeArgsArgument(Data_Foreign_Class.intDecode))(Data_Foreign_Generic_Class.genericCountArgsArgument))(Data_Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "SecondScreen";
}))(Data_Foreign_Generic_Class.genericDecodeArgsArgument(Data_Foreign_Class.intDecode))(Data_Foreign_Generic_Class.genericCountArgsArgument)))((function () {
    var $14 = {};
    for (var $15 in Data_Foreign_Generic.defaultOptions) {
        if ({}.hasOwnProperty.call(Data_Foreign_Generic.defaultOptions, $15)) {
            $14[$15] = Data_Foreign_Generic["defaultOptions"][$15];
        };
    };
    $14.unwrapSingleConstructors = false;
    return $14;
})()));
module.exports = {
    ValueS: ValueS,
    ValueI: ValueI,
    Props: Props,
    genericFirstScreen: genericFirstScreen,
    encodeFirstScreen: encodeFirstScreen,
    decodeFirstScreen: decodeFirstScreen,
    showScreen: showScreen
};



//////////////////
// WEBPACK FOOTER
// ./output/PrestoDOM.Types/index.js
// module id = 99
// module chunks = 0